"use strict";
/** @module models */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LongUnit = exports.MinimalUnit = exports.SubUnit = exports.FullUnit = exports.RequestUnit = void 0;
var cerealParse_1 = require("../cerealParse");
/**
 * Class representing a request unit and providing a static parse method.
 */
var RequestUnit = /** @class */ (function () {
    function RequestUnit(id, name) {
        this.id = id;
        this.name = name;
    }
    /**
     * Parse object potentially representing a RequestUnit.
     * @param o
     * @return Parse result
     */
    RequestUnit.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new RequestUnit(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid RequestUnit: ".concat(e.message));
        }
    };
    return RequestUnit;
}());
exports.RequestUnit = RequestUnit;
/**
 * Class representing a full unit and providing a static parse method.
 */
var FullUnit = /** @class */ (function () {
    function FullUnit(id, name, subunits) {
        this.id = id;
        this.name = name;
        this.subunits = subunits;
    }
    /**
     * Parse object potentially representing a FullUnit.
     * @param o
     * @return Parse result
     */
    FullUnit.parse = function (o) {
        try {
            var requestUnitPart = RequestUnit.parse(o);
            if (requestUnitPart.success == false) {
                return cerealParse_1.ParseUtils.parseFailure("Invalid FullUnit: ".concat(requestUnitPart.justification));
            }
            return cerealParse_1.ParseUtils.parseSuccess(new FullUnit(requestUnitPart.value.id, requestUnitPart.value.name, cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'subunits', SubUnit.parse, 'warn')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid FullUnit: ".concat(e.message));
        }
    };
    return FullUnit;
}());
exports.FullUnit = FullUnit;
/**
 * Class representing a sub unit and providing a static parse method.
 */
var SubUnit = /** @class */ (function () {
    function SubUnit(id, name) {
        this.id = id;
        this.name = name;
    }
    /**
     * Parse object potentially representing a SubUnit.
     * @param o
     * @return Parse result
     */
    SubUnit.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SubUnit(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SubUnit: ".concat(e.message));
        }
    };
    return SubUnit;
}());
exports.SubUnit = SubUnit;
var MinimalUnit = /** @class */ (function () {
    function MinimalUnit(id, agencyId, name) {
        this.id = id;
        this.agencyId = agencyId;
        this.name = name;
    }
    MinimalUnit.prototype.shortId = function () {
        var parts = this.id.split('.');
        return parts[parts.length - 1].toUpperCase();
    };
    MinimalUnit.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new MinimalUnit(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'agencyId'), cerealParse_1.ParseUtils.getString(o, 'name')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid MinimalUnit Model: ".concat(e.message));
        }
    };
    MinimalUnit.compare = function (u1, u2) {
        return u1.name.localeCompare(u2.name) || u1.id.localeCompare(u2.id);
    };
    return MinimalUnit;
}());
exports.MinimalUnit = MinimalUnit;
var LongUnit = /** @class */ (function () {
    function LongUnit(id, agencyId, name, parser, alertEmails, emailForwards, cadDept, groups, showOnSignup) {
        this.id = id;
        this.agencyId = agencyId;
        this.name = name;
        this.parser = parser;
        this.alertEmails = alertEmails;
        this.emailForwards = emailForwards;
        this.cadDept = cadDept;
        this.groups = groups;
        this.showOnSignup = showOnSignup;
    }
    LongUnit.prototype.shortId = function () {
        if (this.cadDept != null) {
            return this.cadDept;
        }
        else {
            var parts = this.id.split('.');
            return parts[parts.length - 1].toUpperCase();
        }
    };
    LongUnit.prototype.getUnitKey = function (agencyKey) {
        var agencyKeyPrefix = "".concat(agencyKey, ".");
        if (this.id.indexOf(agencyKeyPrefix) != 0) {
            return null;
        }
        else {
            return this.id.slice(agencyKeyPrefix.length);
        }
    };
    LongUnit.parse = function (o) {
        var minimalPart = MinimalUnit.parse(o);
        if (minimalPart.success != true) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid LongUnit Model: ".concat(minimalPart.justification));
        }
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new LongUnit(minimalPart.value.id, minimalPart.value.agencyId, minimalPart.value.name, cerealParse_1.ParseUtils.getString(o, 'parser'), cerealParse_1.ParseUtils.getArray(o, 'alertEmails'), cerealParse_1.ParseUtils.getArrayOrNull(o, 'emailForwards') || [], cerealParse_1.ParseUtils.getStringOrNull(o, 'cadDept'), cerealParse_1.ParseUtils.getArray(o, 'groups'), cerealParse_1.ParseUtils.getBoolean(o, 'showOnSignup')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid LongUnit Model: ".concat(e.message));
        }
    };
    LongUnit.compare = function (u1, u2) {
        return u1.name.localeCompare(u2.name) || u1.id.localeCompare(u2.id);
    };
    return LongUnit;
}());
exports.LongUnit = LongUnit;
//# sourceMappingURL=unit.js.map